module.exports = __webpack_public_path__ + "img/a2-s37.57799650.jpg";